
// export const myGetter = ( output ) => {
//  return output
// }

export const outputsList = state => state.outputs
export const outputsSelectable = state => state.outputsSelectable
export const outputsPaginatedData = state => state.outputsPaginatedData
export const output = state => state.output
export const outputsCount = state => state.outputs.length
export const outputSelect = state => state.outputSelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData

export const cancelatedData = state => state.cancelatedData
export const isCancelating = state => state.isCancelating